import { createFileRoute } from "@tanstack/react-router";
import { ClientCompanyContactsPage } from "../../../../pages/clients-page/client-company-contacts-page";

export const Route = createFileRoute("/_auth/_frame/clients/$companyId/contacts")({
  component: ClientCompanyContactsPage,
});
